/**
 * Base URL for assistant APIs (`/api/chat`, `/api/voice/*`).
 * CRA: optional REACT_APP_BACKEND_URL (e.g. http://127.0.0.1:8000) for a separate API host.
 * If unset, returns '' so requests use same-origin paths like `/api/chat` (matches submitContact.js
 * and enables package.json `proxy` in development).
 */
export function getAssistantApiBaseUrl() {
  const raw =
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BACKEND_URL) || '';
  const trimmed = String(raw).trim();
  if (trimmed) {
    return trimmed.replace(/\/+$/, '');
  }
  return '';
}
